import Repository from "./Repository";

const resource = "/RegulatoryNotification";

export type RegulatoryNotificationItem = {
  id: number;
  countryId: number | null;
  countryName: string;
  type: "Regulatory" | "Notification" | "Feature";
  title: string;
  summary: string;
  url: string;
  isVisible: boolean;
  isNew: boolean;
  displayOrder: number;
  isRead?: boolean;
  createdOnUtc: string;
  updatedOnUtc?: string | null;
};

export type SaveRegulatoryNotificationPayload = {
  id: number;
  countryId: number | null;
  type: "Regulatory" | "Notification" | "Feature";
  title: string;
  summary: string;
  url: string;
  isVisible: boolean;
  isNew: boolean;
  displayOrder: number;
};

export default {
  list(type: "Regulatory" | "Notification" | "Feature", countryId?: number | null, visibleOnly = false) {
    const search = new URLSearchParams({
      type,
      visibleOnly: String(visibleOnly),
    });

    if (countryId != null) {
      search.set("countryId", String(countryId));
    }

    return Repository.get(`${resource}/List?${search.toString()}`, { withCredentials: true });
  },
  listUnreadNotifications() {
    return Repository.get(`${resource}/ListUnreadNotifications`, { withCredentials: true });
  },
  save(payload: SaveRegulatoryNotificationPayload) {
    return Repository.post(`${resource}/Save`, payload, { withCredentials: true });
  },
  delete(id: number) {
    return Repository.post(`${resource}/Delete`, { id }, { withCredentials: true });
  },
  reorder(type: "Regulatory" | "Notification" | "Feature", countryId: number | null, items: Array<{ id: number; displayOrder: number }>) {
    return Repository.post(`${resource}/Reorder`, {
      type,
      countryId,
      items,
    }, { withCredentials: true });
  },
  dismiss(regulatoryNotificationId: number) {
    return Repository.post(`${resource}/Dismiss`, { regulatoryNotificationId }, { withCredentials: true });
  },
  dismissAll(regulatoryNotificationIds: number[]) {
    return Repository.post(`${resource}/DismissAll`, { regulatoryNotificationIds }, { withCredentials: true });
  },
};
